import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type {
  MerchantNetworkResponse,
  MerchantOpsResponse,
} from '@/types/merchants';

export function useMerchantNetwork() {
  return useQuery<MerchantNetworkResponse>({
    queryKey: ['merchants', 'network'],
    queryFn: async () => {
      const { data } = await api.get<MerchantNetworkResponse>('/merchants/network');
      return data;
    },
    staleTime: 60_000,
  });
}

export function useMerchantOps() {
  return useQuery<MerchantOpsResponse>({
    queryKey: ['merchants', 'ops'],
    queryFn: async () => {
      const { data } = await api.get<MerchantOpsResponse>('/merchants/ops');
      return data;
    },
    staleTime: 60_000,
  });
}
